import React from 'react';
import { LeadIncident } from './LeadIncident';
import { LeadIntake } from './LeadIntake';
import { LeadRelatedCases } from './LeadRelatedCases';
import { LeadContact } from './LeadContact';
import { LeadDocuments } from './LeadDocuments';
import { LeadPFS } from './LeadPFS';
import { LeadActivity } from './LeadActivity';
import { LeadTasks } from './LeadTasks';

export const LeadSection = ({ 
    user_id, 
    lead_id, 
    leadData, 
    section_id, 
    customFields, 
    relatedCases, 
    folders, 
    metaData,
    fetchDocuments,
    fetchCustomFields,
    phases,
    fieldValues,
    fetchLead,
    contacts,
    fetchContacts
}) => {
    const renderSection = () => {
        switch(section_id) {
            case 1:
                return (
                    <LeadIncident 
                        customFields={customFields} 
                        leadData={leadData} 
                        fetchCustomFields={fetchCustomFields} 
                        phases={phases} 
                        fieldData={fieldValues} 
                        fetchLead={fetchLead} 
                        contacts={contacts} 
                        fetchContacts={fetchContacts}
                    />
                );
            case 2:
                return (
                    <LeadIntake 
                        leadData={leadData} 
                        fetchCustomFields={fetchCustomFields} 
                        contacts={contacts}
                        fetchLead={fetchLead}
                    />
                );
            case 3:
                return (
                    <LeadRelatedCases
                        relatedCases={relatedCases}
                        fetchCustomFields={fetchCustomFields}
                        phases={phases}
                        primaryAttorney={fieldValues?.[0]?.['178']}
                        contact={leadData.contact} 
                    />
                );
            case 4:
                return (
                    <LeadContact 
                        contact={leadData.contact}
                    />
                );
            case 5:
                return (
                    <LeadActivity 
                        user_id = {user_id}
                        lead_id = {lead_id}
                    />
                );
            /*case 6:
                return (
                    <LeadTasks
                        leadData={leadData}
                        fetchCustomFields={fetchCustomFields}
                        contacts={contacts}
                    />
                );*/
            case 7:
                return (
                    <LeadPFS
                        leadData={leadData}
                        fetchCustomFields={fetchCustomFields}
                    />
                )
            case 8:
                return (
                    <LeadDocuments
                        user_id={user_id}
                        lead_id={lead_id}
                        folders={folders}
                        metaData={metaData}
                        fetchDocuments={fetchDocuments}
                    />
                );
            default:
                return <div>Select a section</div>;
        }
    };

    return (
        <div className="lead-section">
            {renderSection()}
        </div>
    );
};
